var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.User.isLogged && +_vm.User.id === +_vm.userId && _vm.isEditable)?_c('v-list-item',{on:{"click":function($event){return _vm.postEdit(_vm.postIdx)}}},[_c('v-list-item-title',[_c('v-icon',[_vm._v("mdi-file-document-edit-outline")]),_vm._v(" Редактировать ")],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }